export const getAnalyticsPathData = (path = '') => {
  const normalize = (value = '') => {
    if (!value) {
      return '/';
    }

    return value.length > 1 ? value.replace(/\/+$/, '') : value;
  };

  const normalizedPath = normalize(path);
  const pathSegments = normalizedPath.split('/').filter(Boolean);
  const page = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : '';

  return {
    path: normalizedPath,
    page,
  };
};
